import {protocolcheck} from './protocolcheck'

// 下载文件
export const fetchUri = (href) => {
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none' // 防止影响页面
  iframe.style.height = 0 // 防止影响页面
  iframe.src = href
  document.body.appendChild(iframe) // 这一行必须，iframe挂在到dom树上才会发请求
  // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
  setTimeout(() => {
    iframe.remove()
  }, 5 * 60 * 1000)
}

// 启动PC端
export const openIPC = (params) => {
  return new Promise((resolve, reject) => {
    var tmpVars = []
    for (const key in params) {
      const element = params[key]
      tmpVars.unshift(key + '=' + element)
    }
    let localClientProtocol = 'gccp6.web://GBQCoProject?' + tmpVars.join('&')
    console.log(`localClientProtocol:${localClientProtocol}`)
    protocolcheck(localClientProtocol, () => {
      reject(new Error('检测到您没有安装客户端'))
      // alert('检测到您没有安装客户端')
    }, () => {
      // fetchUri(localClientProtocol)
      resolve()
    })
  })
}

export default {
  // 计价文件编辑
  fileEdit (constructProjectId, projectid) {
    let params = {
      projectsource: 'csxt',
      region: 'ShenZhen',
      projectid: projectid,
      constructprojectid: constructProjectId,
      projecttype: 'GBQ6'
    }
    openIPC(params)
  }
}
